'use client';

import { JSX, useMemo } from 'react';
import Link from 'next/link';
import styles from './menuList.module.scss';
import GTMEvent from '@lib/gtm_events/GTMEvent';

/**
 * Creates the menu list with avaliability times
 * @param content list content formated correctly
 * @param wide defalts false - sets width to 100%
 * @param extraclass any extra classes that you want to apply
 * @returns List container with lists
 */
const MenuList = ({
    content,
    wide = false,
    extraclass = '',
}: {
    content: string[];
    wide?: boolean;
    extraclass?: string;
}) => {
    // Create food list from content
    const foodlist = useMemo<JSX.Element[]>(() => {
        if (content.length < 1) return []; //Guard against empty

        return content.map((item, index) => {
            const splitted = item.split('\\');
            const messageSplit = splitted[1].split('~');

            return (
                <div key={index}>
                    <Link
                        href={messageSplit[0]}
                        className={`${styles.link}`}
                        target="_blank"
                        onClick={() => {
                            GTMEvent('pdf_download', {
                                pdf_name: `${splitted[0]}`,
                            });
                        }}
                    >
                        {splitted[0]}
                    </Link>
                    {messageSplit[1] && (
                        <p
                            dangerouslySetInnerHTML={{
                                __html: messageSplit[1],
                            }}
                        ></p>
                    )}
                    {content.length - 1 !== index && (
                        <hr className={styles.line} />
                    )}
                </div>
            );
        });
    }, [content]);

    return (
        <div
            className={`${styles.container} ${wide && styles.wide} ${extraclass}`}
        >
            {foodlist}
        </div>
    );
};

export default MenuList;
